<template>
  <fab :size="variant" :id="id" @click="onCopy" >
    <slot>
      <UIcon name="i-pkg-content-copy" :class="[copyIconSizeClass, 'shrink-0 mr-3 text-primary-500']" />
    </slot>

    <b-tooltip :show.sync="show" :noninteractive="true" :target="target" triggers="click" :placement="placement">
      Copied
    </b-tooltip>

  </fab>
</template>

<script>
import Fab from '~/components/xerneas/Button/Fab.vue';

export default {
  components: {
    Fab,
  },
  props: {
    iconSize: {
      type: String,
      default: 'sm'
    },
    variant: {
      type: String,
      default: 'fab-transparent'
    },  
    message: {
      type: String,
      default: '',
    },
    parent: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'top',
    },
  },
  computed: {
    id() {
      return `copy-${Math.random()}`;
    },
    target() {
      return this.parent || this.id;
    },
    copyIconSizeClass() {
      const sizeMap = {
        tiny: 'size-3',
        sm: 'size-4',
        md: 'size-5',
        lg: 'size-6',
      };
      return sizeMap[this.iconSize] || 'size-5';
    },
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    show() {
      setTimeout(() => {
        this.show = false;
      }, 3000);
    },
  },
  methods: {
    async onCopy() {
      try {
        await this.$copyText(this.message);
        this.show = true;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
